import { ValueType } from "./valueTypes";
import { getEnumAllowedCodes } from "./parseOptionsJson";

function normalizeType(valueType) {
    const type = String(valueType || "").trim().toUpperCase();
    switch (type) {
        case "NUMERIC":
            return ValueType.Numeric;
        case "STRING":
            return ValueType.String;
        case "BOOLEAN":
            return ValueType.Boolean;
        case "ENUM":
            return ValueType.Enum;
        case "ARRAY":
            return ValueType.Array;
        case "JSON":
            return ValueType.Json;
        case "DATE":
            return ValueType.Date;
        case "DURATION":
            return "DURATION";
        case "COLOR":
            return "COLOR";
        case "URL":
            return "URL";
        case "ASSET_REF":
            return "ASSET_REF";
        case "ENTITY_REF":
            return "ENTITY_REF";
        default:
            return valueType;
    }
}

export function normalizeValueByType(valueType, raw, options) {
    try {
        switch (normalizeType(valueType)) {
            case ValueType.Numeric: {
                const num = Number(raw);
                if (Number.isNaN(num)) return { ok: false, err: "Число некорректно" };
                return { ok: true, str: String(num) };
            }
            case ValueType.Boolean: {
                const v = String(raw).trim().toLowerCase();
                if (v === "true" || v === "1" || v === "yes") return { ok: true, str: "true" };
                if (v === "false" || v === "0" || v === "no") return { ok: true, str: "false" };
                return { ok: false, err: "Ожидается true/false" };
            }
            case ValueType.Date: {
                const mode = options?.mode || "date";
                const s = String(raw).trim();
                if (mode === "time") {
                    if (!/^\d{2}:\d{2}:\d{2}$/.test(s)) return { ok: false, err: "Формат HH:mm:ss" };
                    return { ok: true, str: s };
                }
                if (mode === "datetime") {
                    if (!s || Number.isNaN(Date.parse(s))) return { ok: false, err: "Некорректные дата и время" };
                    return { ok: true, str: s };
                }
                if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return { ok: false, err: "Формат YYYY-MM-DD" };
                return { ok: true, str: s };
            }
            case ValueType.Json: {
                const s = String(raw).trim();
                if (!s) return { ok: false, err: "JSON пуст" };
                JSON.parse(s);
                return { ok: true, str: s };
            }
            case ValueType.Array: {
                const s = String(raw).trim();
                if (!s) return { ok: true, str: "[]" };
                if (/^\s*\[.*\]\s*$/.test(s)) { JSON.parse(s); return { ok: true, str: s }; }
                const parts = s.split(",").map((x) => x.trim()).filter(Boolean);
                return { ok: true, str: JSON.stringify(parts) };
            }
            case "DURATION": {
                const num = Number(raw);
                if (Number.isNaN(num) || !Number.isInteger(num)) return { ok: false, err: "Ожидается целое число миллисекунд" };
                return { ok: true, str: String(num) };
            }
            case "COLOR": {
                const s = String(raw).trim();
                if (!/^#[0-9A-Fa-f]{8}$/.test(s)) return { ok: false, err: "Формат #RRGGBBAA" };
                return { ok: true, str: s };
            }
            case "URL": {
                const s = String(raw).trim();
                try {
                    const parsed = new URL(s);
                    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
                        return { ok: false, err: "Только http/https" };
                    }
                    return { ok: true, str: s };
                } catch {
                    return { ok: false, err: "Некорректный URL" };
                }
            }
            case "ASSET_REF":
            case "ENTITY_REF": {
                const s = String(raw).trim();
                if (!s) return { ok: false, err: "Укажите UUID или JSON-массив UUID" };
                if (/^\s*\[.*\]\s*$/.test(s)) {
                    JSON.parse(s);
                    return { ok: true, str: s };
                }
                if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(s)) {
                    return { ok: false, err: "Ожидается UUID" };
                }
                return { ok: true, str: s };
            }
            case ValueType.Enum: {
                const codes = getEnumAllowedCodes(options);
                const allowedCodes = codes.length ? codes : null;
                if (options?.multiple) {
                    let arr;
                    try {
                        arr = JSON.parse(String(raw ?? "[]") || "[]");
                    } catch {
                        return { ok: false, err: "Некорректный список значений" };
                    }
                    if (!Array.isArray(arr)) return { ok: false, err: "Ожидается массив значений" };
                    if (allowedCodes && arr.some((code) => !allowedCodes.includes(code))) {
                        return { ok: false, err: "Значение не входит в список допустимых" };
                    }
                    return { ok: true, str: JSON.stringify(arr) };
                }
                const s = String(raw ?? "").trim();
                if (!s) return { ok: false, err: "Выберите значение" };
                if (allowedCodes && !allowedCodes.includes(s)) {
                    return { ok: false, err: "Значение не входит в список допустимых" };
                }
                return { ok: true, str: s };
            }
            case ValueType.String:
            default:
                return { ok: true, str: String(raw ?? "") };
        }
    } catch (e) {
        return { ok: false, err: e.message || "Некорректное значение" };
    }
}
